import isMobileWeb from 'is-mobile';
import * as qs from 'qs';
import { useLocation } from 'react-router';

import type { Sport } from '__generated__/globalTypes';
import { SignupPlatform } from '__generated__/globalTypes';
import { useAfterLoggedInTarget } from 'hooks/useAfterLoggedInTarget';
import { useIsMobileApp } from 'hooks/useIsMobileApp';
import { useQueryString } from 'hooks/useQueryString';
import { localStorage } from 'lib/storage/localStorage';

type Props = {
  sport?: Sport;
};

export const useOAuthParams = ({ sport }: Props) => {
  const action = useQueryString('action');
  const location = useLocation();
  const afterLoggedInTarget = useAfterLoggedInTarget();
  const { isMobileApp, isAndroidApp } = useIsMobileApp();

  const signupPlatform = (() => {
    if (isMobileApp && isAndroidApp) return SignupPlatform.ANDROID;
    if (isMobileWeb()) return SignupPlatform.MOBILE_WEB;
    return SignupPlatform.WEB;
  })();

  return {
    referrer: localStorage.getItem('referrer'),
    signup_platform: signupPlatform,
    signup_sport: sport,
    impact_click_id: localStorage.getItem('irclickid'),
    google_click_id: localStorage.getItem('gclid'),
    facebook_click_id: localStorage.getItem('fbclid'),
    twitter_click_id: localStorage.getItem('twclid'),
    tik_tok_click_id: localStorage.getItem('ttclid'),
    snapchat_click_id: localStorage.getItem('ScCid'),
    reddit_click_id: localStorage.getItem('rdt_cid'),
    invitation_token: localStorage.getItem('invitation_token'),
    utm_campaign: localStorage.getItem('utm_campaign'),
    utm_source: localStorage.getItem('utm_source'),
    utm_medium: localStorage.getItem('utm_medium'),
    utm_term: localStorage.getItem('utm_term'),
    utm_content: localStorage.getItem('utm_content'),
    partner: localStorage.getItem('partner'),
    user: localStorage.getItem('user'),
    traffic_category: localStorage.getItem('traffic_category'),
    after_logged_in_target:
      afterLoggedInTarget ||
      (action
        ? qs.stringify({ action }, { skipNulls: true, addQueryPrefix: true })
        : location.pathname),
  };
};
